import { concat, hash } from '@ember/helper';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { consume } from 'ember-provide-consume-context';
import { eq } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import Date from './date';
import SelectCustom from './select-custom';
import SelectRelationship from './select-relationship';
import SelectValueLabel from './select-value-label';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerToolbarFiltersComponent extends Component {
  @consume('window') isWindowCompact;

  <template>
    <div class={{bem (hash is-compact=this.isWindowCompact)}} ...attributes>
      {{#each @availableFilters as |filter|}}
        {{#unless (eq filter.type 'externalFilter')}}
          <div class={{bem 'filter'}}>
            <label class={{bem 'label'}}>
              {{t (concat 'tables.filters.' filter.key)}}
            </label>

            <div class={{bem 'field'}}>
              {{#if (eq filter.type 'date')}}
                <Date
                  @recordType={{@recordType}}
                  @filter={{filter}}
                  @activeFilters={{@activeFilters}}
                  @onChangeFilter={{@onChangeFilter}}
                />
              {{else if (eq filter.type 'selectValueLabel')}}
                <SelectValueLabel
                  @recordType={{@recordType}}
                  @filter={{filter}}
                  @activeFilters={{@activeFilters}}
                  @onChangeFilter={{@onChangeFilter}}
                />
              {{else if (eq filter.type 'selectCustom')}}
                <SelectCustom
                  @recordType={{@recordType}}
                  @filter={{filter}}
                  @activeFilters={{@activeFilters}}
                  @onChangeFilter={{@onChangeFilter}}
                />
              {{else if (eq filter.type 'selectRelationship')}}
                <SelectRelationship
                  @filter={{filter}}
                  @activeFilters={{@activeFilters}}
                  @onChangeFilter={{@onChangeFilter}}
                />
              {{/if}}
            </div>
          </div>
        {{/unless}}
      {{/each}}
    </div>
  </template>
}
